Router = App.loadClass 'core::Router'

class exports.OnFarmStorageRouter extends Router

    prefix: 'OnFarmStorage'
    module_name: 'OnFarmStorageRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'portal::Angular/OnFarmStorage/OnFarmStorageService', ['$http', '$resource', '$state']

        @controller 'portal::Angular/OnFarmStorage/OnFarmStorageController', [
            '$scope'
            '$transitions'
            '$state'
            '$uibModal'
            'OnFarmStorage.Services.OnFarmStorageService'
            'Core.Services.Loading'
            '$q'
        ]

        @controller 'portal::Angular/OnFarmStorage/modals/BinInspectionsController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'OnFarmStorage.Services.OnFarmStorageService'
            'Core.Services.Loading'
            'bin'
            'year'
        ]


    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'portal.onfarmstorage',
                url: '/onfarmstorage'
                templateUrl: 'backend/portal/on-farm-storage/sidebar-layout'
                controller: ['$scope', '$state', ($scope, $state) ->
                    $scope.show_fullpage = true
                    $state.go 'portal.onfarmstorage.fullpage', null,
                        location: false
                ]

            .state 'portal.onfarmstorage.fullpage',
                url: '/load'
                views:
                    fullpage:
                        templateUrl: 'backend/portal/on-farm-storage/main-layout'
                        controller: 'OnFarmStorage.Controllers.OnFarmStorageController'
                        controllerAs: 'ofs'
